module.exports = __webpack_public_path__ + "static/media/15.831308a0.jpg";